import { ActionReducerMap } from '@ngrx/store';
import { PointsViewColumnViewModelStates } from '../states';
import * as fromColumn1ViewModelReducers from './column_1_view_model.reducers';
export const columnViewModelFeatureKey2 = 'genericDocPointsViewModel';
export const columnViewModelReducers2: ActionReducerMap<PointsViewColumnViewModelStates> = {
  column1ViewModel: fromColumn1ViewModelReducers.reducer,
};